<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> criterio medición de brechas <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content fxLayout="column" >
    <div fxLayout="column"  fxFlex >
      <div fxFlex>
        <mat-form-field *ngIf="action != 'Delete'" class="select-list">
          <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled] ="action == 'View'">
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field  fxFlex>
          <mat-label>Tipo de tabla</mat-label>
          <mat-select [(ngModel)]="LOCAL_DATA.tipo" class="roleSelect" (selectionChange)="selectTipo()" [disabled] ="action == 'View'"> 
              <mat-option *ngFor="let tipoTabla of tiposTabla" [value]="tipoTabla">
                  {{tipoTabla | titlecase | spacecleaner}}
              </mat-option> 
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field  fxFlex *ngIf="LOCAL_DATA.tipo=='EVALUACION_MULTIPLE'">
          <mat-label>Tipo de valor</mat-label>
          <mat-select [(ngModel)]="LOCAL_DATA.subtipo" class="roleSelect" (selectionChange)="selectTipo()" [disabled] ="action == 'View'"> 
              <mat-option *ngFor="let tipoValor of tiposValor" [value]="tipoValor">
                  {{tipoValor | titlecase | spacecleaner}}
              </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
        <!--
          <mat-form-field color="accent" appearance="fill">
            <mat-label>Fecha de creación</mat-label>
            <input matInput [matDatepicker]="LOCAL_DATA.fechaCreacion">
            <mat-datepicker-toggle matSuffix [for]="LOCAL_DATA.fechaCreacion"></mat-datepicker-toggle>
            <mat-datepicker #LOCAL_DATA.fechaCreacion></mat-datepicker>
          </mat-form-field>-->
          <!-- CONTENT CARD -->
    <div class="content-card" *ngIf="action != 'Delete'">

      <div fxLayout="row" fxLayoutAlign="end end">
        <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row" *ngIf="action == 'View'">
          <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
        </button>
        </div>

        <mat-card class="example-card">
          <mat-card-header>
            <mat-card-title></mat-card-title>

          </mat-card-header>

          <mat-card-content *ngIf="LOCAL_DATA.tipo==='EVALUACION_SIMPLE'">
            <div class="content p-5" fxLayout="column">

              <div fxLayout="row"  fxFlex *ngIf="action != 'View' && action != 'Delete'">
                <div fxLayout="column" fxFlex>
                    
                    <div fxFlex>
                      <mat-form-field *ngIf="action != 'Delete'" fxFlex="40">
                        <input placeholder="Nombre" matInput [(ngModel)]="new_line_p.nombre" maxlength="40">
                      </mat-form-field>
                      <!-- TIPO-->
                      <mat-form-field *ngIf="action != 'Delete'" fxFlex="20">
                        <input placeholder="Valor" matInput [(ngModel)]="new_line_p.valor"
                        onkeypress="return event.charCode >= 48"
                        type="number" value="" min="0"  pattern="[0-9]+" step="any">
                      </mat-form-field>
                      <mat-form-field *ngIf="action != 'Delete'" fxFlex="40">
                        <mat-label>Descripción</mat-label>
                        <textarea
                              matInput [(ngModel)]="new_line_p.descripcion"
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="5"></textarea>
                      </mat-form-field>
                      <div fxFlex="20">
                        <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row">Grabar</button>
                      </div>
                    </div>
                  </div>

                </div>
                <div fxFlex *ngIf="action != 'Delete'">
                  <table mat-table [dataSource]="dataSource" #tableOpciones class="my-table mat-elevation-z8 select-list" >

                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- User Column -->

                    <ng-container matColumnDef="nombre">
                      <th mat-header-cell *matHeaderCellDef> Nombre </th>
                      <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                    </ng-container>

                    <ng-container matColumnDef="descripcion">
                      <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                      <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valor">
                      <th mat-header-cell *matHeaderCellDef> Valor </th>
                      <td mat-cell *matCellDef="let element"> {{element.valor}} </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef> Acción </th>
                      <td mat-cell *matCellDef="let element" class="action-link">
                        <a (click)="edit(element)" *ngIf="action != 'View' && action != 'Delete'">Editar</a>
                        <span *ngIf="action != 'View' && action != 'Delete'">|</span>
                        <a (click)="remove(element)" *ngIf="action != 'View' && action != 'Delete'">Eliminar</a>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>
                </div>
            </div>
          </mat-card-content>

          <mat-card-content *ngIf="LOCAL_DATA.tipo==='EVALUACION_MULTIPLE'">
            <div class="content p-5" fxLayout="column">

              <div fxLayout="row"  fxFlex *ngIf="action != 'View' && action != 'Delete'">
                <div fxLayout="column" fxFlex>
                    
                    <div fxFlex>
                      <mat-form-field *ngIf="action != 'Delete'" fxFlex="40">
                        <input placeholder="Nombre" matInput [(ngModel)]="new_line_p.nombre" maxlength="40">
                      </mat-form-field>
                      <!-- TIPO-->
                      <mat-form-field *ngIf="action != 'Delete' && LOCAL_DATA.subtipo==='RANGO_VALORES'" fxFlex="20">
                        <input placeholder="Valor mínimo" matInput [(ngModel)]="new_line_p.valorMinimo"
                        onkeypress="return event.charCode >= 48"
                        type="number" value="" min="0"  pattern="[0-9]+" step="any">
                      </mat-form-field>
                      <mat-form-field *ngIf="action != 'Delete' && LOCAL_DATA.subtipo==='RANGO_VALORES'" fxFlex="20">
                        <input placeholder="Valor máximo" matInput [(ngModel)]="new_line_p.valorMaximo"
                        onkeypress="return event.charCode >= 48"
                        type="number" value="" [min]="new_line_p.valorMinimo"  pattern="[0-9]+" step="any">
                      </mat-form-field>
                      <mat-form-field *ngIf="action != 'Delete'" fxFlex="40">
                        <mat-label>Descripción</mat-label>
                        <textarea
                              matInput [(ngModel)]="new_line_p.descripcion"
                              cdkTextareaAutosize
                              #autosize="cdkTextareaAutosize"
                              cdkAutosizeMinRows="1"
                              cdkAutosizeMaxRows="5"></textarea>
                      </mat-form-field>
                      <div fxFlex="20">
                        <button mat-button (click)="addLineMultiple()" mat-flat-button color="primary" class="add-row">Grabar</button>
                      </div>
                    </div>
                  </div>

                </div>
                <div fxFlex *ngIf="action != 'Delete'">
                  <table mat-table [dataSource]="dataSourceMultiple" #tableOpciones class="my-table mat-elevation-z8 select-list" >

                    <!--- Note that these columns can be defined in any order.
                        The actual rendered columns are set as a property on the row definition" -->

                    <!-- User Column -->

                    <ng-container matColumnDef="nombre" fxFlex="20">
                      <th mat-header-cell *matHeaderCellDef> Nombre </th>
                      <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                    </ng-container>

                    <ng-container matColumnDef="descripcion" fxFlex="40">
                      <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                      <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valor" fxFlex="10">
                      <th mat-header-cell *matHeaderCellDef> Valor</th>
                      <td mat-cell *matCellDef="let element"> 
                        <div *ngIf="tipoValor === 'Cumple/No cumple'">Cumple/No cumple</div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="valorMinimo" fxFlex="10">
                      <th mat-header-cell *matHeaderCellDef> Valor Mínimo</th>
                      <td mat-cell *matCellDef="let element"> 
                        {{element.valorMinimo}}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="valorMaximo" fxFlex="10">
                      <th mat-header-cell *matHeaderCellDef> Valor Máximo</th>
                      <td mat-cell *matCellDef="let element"> 
                        {{element.valorMaximo}}
                      </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="action" fxFlex="15">
                      <th mat-header-cell *matHeaderCellDef> Acción </th>
                      <td mat-cell *matCellDef="let element" class="action-link">
                        <a (click)="edit(element)" *ngIf="action != 'View' && action != 'Delete'">Editar</a>
                        <span *ngIf="action != 'View' && action != 'Delete'">|</span>
                        <a (click)="removeMultiple(element)" *ngIf="action != 'View' && action != 'Delete'">Eliminar</a>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsMultiple"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsMultiple;"></tr>
                  </table>
                </div>
            </div>
          </mat-card-content>

        </mat-card>

    </div>
    <!-- / CONTENT CARD -->



</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
